module.exports = __webpack_public_path__ + "static/media/lab_background_tablet_sm.c7007bb7.jpg";